import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { Flex, Input, Typography, Select, DatePicker } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { packetsServicesAction } from "src/store/Slices/Administrator/PacketsServicesSlice";
import { openNotification } from "src/components/helpers/notification";
import { getClubs, getServices } from "src/store/Slices/DropDownSlice";
import dayjs from "dayjs";

const AddEditPacketsTrainingsModal = ({
  visible,
  setVisible,
  packetsTrainingsInfo,
  setPage,
  setPageSize,
}) => {
  const dispatch = useDispatch();

  const [month, setMonth] = useState();
  const [trains, setTrains] = useState();
  const [serviceId, setserviceId] = useState();
  const [price, setPrice] = useState();
  const [club, setclub] = useState();

  const services = useSelector((state) => state.DropDownSlice.services);
  const clubs = useSelector((state) => state.DropDownSlice.clubs);

  useEffect(() => {
    setMonth();
    setTrains();
    setserviceId();
    setPrice();
    setclub();
  }, [visible.flag]);

  useEffect(() => {
    console.log(packetsTrainingsInfo)
    if (visible.flag === "edit") {
      setserviceId(
        services?.data?.value.find(
          (el) => el.label === packetsTrainingsInfo?.serviceName
        )?.value
      );
      setMonth(packetsTrainingsInfo?.monthsActive);
      setTrains(packetsTrainingsInfo?.numberOfTrainings);
      setPrice(packetsTrainingsInfo?.price);
      setclub(clubs?.data?.value.find(
          (el) => el.label === packetsTrainingsInfo?.clubName
        )?.value);
    }
  }, [visible, packetsTrainingsInfo]);

  useEffect(() => {
    dispatch(getServices());
    dispatch(getClubs())
  }, [visible]);

  const onClickSubmit = () => {
    !(serviceId && trains && price)
      ? openNotification({
          type: "error",
          message: `Заполните первые три поля`,
        })
      : ''
    dispatch(
      packetsServicesAction({
        flag: visible.flag === "add" ? "put" : "post",
        value: {
          packetId: visible.flag !== "add" ? packetsTrainingsInfo.id : undefined,
          serviceId: serviceId,
          monthsCount: Number(month),
          trainingsCount: Number(trains),
          price: price,
          clubId: club || undefined,
        },
      })
    ).then(() => {
      dispatch(packetsServicesAction({ flag: "get" })).then(() => {
        setVisible({ open: false, flag: "" });
        setPage(1);
        setPageSize(20);
      });
    });
  };

  return (
    <CModal
      alignment="center"
      visible={visible.open}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setVisible({ open: false, flag: "" });
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {visible.flag === "add" ? "Добавить пакет" : "Редактировать пакет"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Услуга</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder="Выбрать"
                onClick={() => {
                  visible.flag === "add" && dispatch(getServices());
                }}
                value={serviceId}
                onChange={(e) => {
                  setserviceId(e);
                }}
                disabled={visible.flag === "add" ? false : true}
                options={services?.data?.value}
              />
            </div>

            <div>
              <Typography.Title level={5}>Число тренировок</Typography.Title>
              <Input
                value={trains}
                type="number"
                onChange={(e) => setTrains(e.currentTarget.value)}
              />
            </div>
            <div>
              <Typography.Title level={5}>Цена</Typography.Title>
              <Input
                value={price}
                type="number"
                onChange={(e) => setPrice(e.currentTarget.value)}
              />
            </div>
            <div>
              <Typography.Title level={5}>Число месяцев</Typography.Title>
              <Input
                value={month}
                type="number"
                onChange={(e) => setMonth(e.currentTarget.value)}
              />
            </div>
            <div>
              <Typography.Title level={5}>Клуб</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder="Выбрать"
                onClick={() => {
                  visible.flag === "add" && dispatch(getClubs());
                }}
                value={club}
                onChange={(e) => {
                  setclub(e);
                }}
                disabled={visible.flag === "add" ? false : true}
                options={clubs?.data?.value}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible({ open: false, flag: "" });
          }}
          className="text-light"
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className="text-light">
          {visible.flag === "add" ? "Добавить" : "Редактировать"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddEditPacketsTrainingsModal;
